import { render } from "./WebDevelopment.vue?vue&type=template&id=d836a658"
import script from "./WebDevelopment.vue?vue&type=script&lang=js"
export * from "./WebDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kojimakazuya/Projects/improver-corp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__